module.exports = __webpack_public_path__ + "media/images/front/no_photo-dcdd929bd24407422e3be85eaa4cc572.png";